import { Transition } from "@headlessui/react";
import { useState } from "react";

interface CardSide {
  src: string;
  alt: string;
}

interface FlipCardProps {
  front: CardSide;
  back: CardSide;
}

export function FlipCard({ front, back }: FlipCardProps) {
  const [flipped, setFlipped] = useState(false);
  return (
    <button
      className="w-full max-w-md [perspective:1000px] cursor-pointer"
      onClick={() => setFlipped(!flipped)}
      type="button"
    >
      <div
        className={`relative aspect-[675/426] w-full duration-700
          [transform-style:preserve-3d]
          ${flipped ? "[transform:rotateY(180deg)]" : ""}
        `}
      >
        {/* FRONT */}
        <Transition
          show={!flipped}
          enter="transition-opacity duration-150 delay-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <img
            alt={front.alt}
            src={front.src}
            className="absolute inset-0 w-full h-full rounded-md shadow-sm
              [backface-visibility:hidden]"
          />
        </Transition>

        {/* BACK */}
        <Transition
          show={flipped}
          enter="transition-opacity duration-150 delay-150"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <img
            alt={back.alt}
            src={back.src}
            className="absolute inset-0 w-full h-full rounded-md shadow-sm
              [transform:rotateY(180deg)]
              [backface-visibility:hidden]"
          />
        </Transition>
      </div>
      <p className="mt-2 flex items-center gap-1 text-sm text-neutral-500 select-none absolute right-2">
        Klicken zum Drehen
      </p>
    </button>
  );
}
